import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/swiper.min.css';
import { useContent } from '../../services';

const specialImages = {
  'menu-image-11.jpg': require('../../assets/images/resource/menu-image-11.jpg'),
  'menu-image-12.jpg': require('../../assets/images/resource/menu-image-12.jpg'),
  'menu-image-13.jpg': require('../../assets/images/resource/menu-image-13.jpg'),
  'menu-image-14.jpg': require('../../assets/images/resource/menu-image-14.jpg'),
};

SwiperCore.use([Navigation]);

function Special() {
  const { data: specials, loading } = useContent('homeSpecials');

  if (loading || !specials) return null;

  const options = {
    slidesPerView: 4,
    spaceBetween: 45,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 7000,
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 15 },
      600: { slidesPerView: 1, spaceBetween: 15 },
      768: { slidesPerView: 2, spaceBetween: 30 },
      992: { slidesPerView: 3, spaceBetween: 30 },
      1200: { slidesPerView: 4 },
    },
  };

  return (
    <>
      <section className="special-offer">
        <div className="outer-container">
          <div className="auto-container">
            <div className="title-box centered">
              <div className="subtitle">
                <span>{specials.subtitle}</span>
              </div>
              <div className="pattern-image">
                <img src={require('../../assets/images/icons/separator.svg').default} alt="mySvgImage" />
              </div>
              <h2>{specials.title}</h2>
            </div>
            <Swiper className="dish-gallery-slider" {...options}
              loop={true}
              spaceBetween={45}
              slidesPerView={4}
              navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
            >
              {specials.items.map((item, index) => (
                <SwiperSlide key={item.id} className={`offer-block-two${index % 2 === 1 ? ' margin-top' : ''}`}>
                  <div className="inner-box">
                    <div className="image">
                      <Link to="/">
                        <img src={specialImages[item.image]} alt="" />
                      </Link>
                    </div>
                    <h4>
                      <Link to="#">{item.name}</Link>
                    </h4>
                    <div className="text desc">{item.description}</div>
                    <div className="price">{item.price}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="swiper-button-prev">
              <span className="fal fa-angle-left"></span>
            </div>
            <div className="swiper-button-next">
              <span className="fal fa-angle-right"></span>
            </div>
            <div className="lower-link-box text-center">
              <Link to={specials.cta.link} className="theme-btn btn-style-two clearfix">
                <span className="btn-wrap">
                  <span className="text-one">{specials.cta.label}</span>
                  <span className="text-two">{specials.cta.label}</span>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section >
    </>
  );
}

export default Special;
